export interface HandicapHistoryEntry {
  from: number;
  to: number;
  t: string;
}

const KEY = (memberId: string) => `bagtag:hcp-history:${memberId}`;

export function loadHandicapHistory(memberId: string): HandicapHistoryEntry[] {
  try {
    const raw = localStorage.getItem(KEY(memberId));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as HandicapHistoryEntry[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function recordHandicapChange(memberId: string, from: number | null, to: number | null): void {
  if (from == null || to == null || from === to) return;
  const history = loadHandicapHistory(memberId);
  history.push({ from, to, t: new Date().toISOString() });
  localStorage.setItem(KEY(memberId), JSON.stringify(history.slice(-20)));
}
